export type GraphQLError = {
    message: string;
    extensions?: Record<string, unknown>;
};

function getOperationName(query: string) {
    // https://regex101.com/r/SDICae/1
    const regex = new RegExp(/(?:query\s|mutation\s)(.*?)(?=\(|\s{)/);
    const matching = regex.exec(query);

    if (!matching) {
        return null;
    }

    return matching[1];
}

type FetchGraphqlOptions = {
    signal?: AbortSignal;
    headers?: HeadersInit;
};

export async function fetchGraphql<Query, Variables = Record<string, unknown>>(
    query: string,
    variables?: Variables,
    options: FetchGraphqlOptions = {}
): Promise<{
    data?: Query;
    errors?: GraphQLError[];
}> {
    try {
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'x-api-key': process.env['NEXT_PUBLIC_API_KEY'] || '',
            ...(options.headers || {})
        };

        const response = await fetch(
            process.env['NEXT_PUBLIC_GRAPHQL_API'] || '',
            {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    query,
                    variables,
                    operationName: getOperationName(query)
                }),
                mode: 'cors',
                credentials: 'include',
                signal: options.signal
            }
        );

        if (!response.ok) {
            return Promise.reject({
                error: {
                    name: 'InvalidResponse',
                    message: `invalid response: ${response.status}`
                }
            });
        }

        return await response.json();
    } catch (error) {
        if (error instanceof Error) {
            return Promise.reject({
                error: {
                    name: error.name,
                    message: error.message
                }
            });
        }

        return Promise.reject({
            error: {
                name: 'UnknownError',
                message: `unexpected error: ${error}`
            }
        });
    }
}

export default fetchGraphql;
